export default {
  label: '矿山经理',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '矿山经理全面负责矿山的开发设计、生产布局及人员组织架构建设',
          id: '0-1-1',
        }
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '制定矿山开发设计和生产布局方案',
          id: '0-2-1',
        },
        {
          label: '组织并监督矿山安全生产，制定内部管理制度',
          id: '0-2-2'
        },
        {
          label: '控制预算开支并合理安排成本',
          id: '0-2-3'
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备丰富的矿山管理经验，熟悉矿山地质地貌特征及开采工艺',
          id: '0-3-1',
        },
        {
          label: '具有较强的组织协调能力、执行能力和决策能力',
          id: '0-3-2',
        }
      ]
    }
  ]
};